﻿export const menuLocaleDict = {
    ru: {
        selectLang: 'Выбрать язык',
        createTask: 'Создать задачу',
        reportError: 'Сообщить об ошибке',
        messengers: 'Мессенджеры'
    },
    en: {
        selectLang: 'Select language',
        createTask: 'Create task',
        reportError: 'Report error',
        messengers: 'Messengers'
    },
    th: {
        selectLang: 'เลือกภาษา',
        createTask: 'สร้างงาน',
        reportError: 'รายงานข้อผิดพลาด',
        messengers: 'ผู้ส่งสาร'
    },
    tr: {
        selectLang: 'Dil seç',
        createTask: 'Görev oluştur',
        reportError: 'Hata bildir',
        messengers: 'Mesajlaşma'
    }
};
